/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconDenglu2: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M756.11788 640.491443c24.466228 0 44.270273-19.904329 44.270273-44.404326 0-14.135952-6.580882-26.715455-16.83441-34.846646l0.231267-0.279363c-34.069957-26.452465-71.943542-48.136324-112.840998-63.830771 52.052516-44.799322 85.172845-111.145379 85.172845-185.343265 0-134.86664-109.036345-244.233514-243.496733-244.233514-134.464481 0-243.496733 109.366873-243.496733 244.233514 0 74.197886 33.116235 140.543943 85.172845 185.343265C188.18908 561.050136 69.990051 722.148208 69.901023 911.3565l0 0.083911c0.089028 24.457018 19.886933 44.321438 44.275389 44.321438 24.468275 0 44.182268-19.86442 44.270273-44.321438 0-195.881272 158.925592-355.246887 354.174462-355.246887 80.056314 0 153.758919 27.084868 213.094306 72.157413C733.644029 635.871215 744.337579 640.491443 756.11788 640.491443L756.11788 640.491443zM512.62217 467.204771c-85.434811 0-154.950048-69.730131-154.950048-155.417699 0-85.688591 69.520353-155.424862 154.950048-155.424862s154.950048 69.736271 154.950048 155.424862C667.572218 397.47464 598.051865 467.204771 512.62217 467.204771L512.62217 467.204771zM512.62217 467.204771M924.986939 789.326213l-66.407456 0 0-66.614164c0-18.384719-14.869662-33.305547-33.20424-33.305547-18.376533 0-33.20424 14.920828-33.20424 33.305547l0 66.614164-66.402339 0c-18.376533 0-33.20424 14.916734-33.20424 33.299407 0 18.388812 14.82873 33.305547 33.20424 33.305547l66.402339 0 0 66.609047c0 18.389836 14.82873 33.305547 33.20424 33.305547 18.334577 0 33.20424-14.914688 33.20424-33.305547l0-66.609047 66.407456 0c18.334577 0 33.20424-14.916734 33.20424-33.305547C958.191178 804.241924 943.321516 789.326213 924.986939 789.326213L924.986939 789.326213zM924.986939 789.326213"
        fill={getIconColor(color, 0, '#272636')}
      />
    </svg>
  );
};

IconDenglu2.defaultProps = {
  size: 18,
};

export default IconDenglu2;
